import { createConfig } from "@Utils/createConfig";
import axios from "axios";
import { gatewayUrl } from "@Constants/gatewayUrl";
import { TimelineType } from "@juristic/types/models/timeline";
export async function getTimelineElements(token, timelineId) {
    const header = createConfig(token);
    const timelineType = TimelineType.Table;
    const headerParams = {
        timelineType,
        isCompactMode: undefined,
        stretch: undefined
    };
    header.params = headerParams;
    const url = `${gatewayUrl}/timelines/getElements/${timelineId}`;
    return await axios.get(url, header);
}
